// USER
export const GETTER_SIGNUP_GET = "user/GETTER_SIGNUP_GET";
// PROFIL
export const GETTER_PROFILE_GET = "profile/GETTER_PROFILE_GET";
export const GETTER_ADMIN_FOLDER_GET = "profile/GETTER_ADMIN_FOLDER_GET";
export const GETTER_PROFILE_GET_ACCOUNT = "profile/GETTER_PROFILE_GET_ACCOUNT";
export const GETTER_PROFILE_GET_SUBSCRIPTION_STATUS = "profile/GETTER_PROFIL_GET_SUBSCRIPTION_STATUS";
// FAMILIES
export const GETTER_FAMILY = "family/GETTER_FAMILY_ETAB";
// DASHBOARD
export const GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED = "dashboard/GETTER_DASHBOARD_RECRUITMENT_RECAP_MODAL_OPENED";
export const GETTER_DASHBOARD_RECRUITMENT_RECAP = "dashboard/GETTER_DASHBOARD_RECRUITMENT_RECAP";
export const GETTER_DASHBOARD_TITLE = "dashboard/GETTER_DASHBOARD_TITLE";
// CREATION DEMAND
export const GETTER_CREATION_DEMAND_GET = "creation_demand/GETTER_CREATION_DEMAND_GET";
export const GETTER_CREATION_DEMAND_GET_PUBLISHED_ID = "creation_demand/GETTER_CREATION_DEMAND_GET_PUBLISHED_ID";
export const GETTER_CREATION_DEMAND_GET_PUBLISHED_TYPE = "creation_demand/GETTER_CREATION_DEMAND_GET_PUBLISHED_TYPE";
export const GETTER_CREATION_DEMAND_GET_DURATION_PRICE = "creation_demand/GETTER_CREATION_DEMAND_GET_DURATION_PRICE";

// QUALIFICATIONS
export const GETTER_QUALIFICATIONS_GET_FAMILIES = "qualifications/GETTER_QUALIFICATIONS_GET_FAMILIES";
export const GETTER_QUALIFICATIONS_GET_ALL = "qualifications/GETTER_QUALIFICATIONS_GET_ALL";
export const GETTER_QUALIFICATIONS_GET_FROM_FAMILY = "qualifications/GETTER_QUALIFICATIONS_GET_FROM_FAMILY";
export const GETTER_QUALIFICATIONS_GET_FROM_ID = "qualifications/GETTER_QUALIFICATIONS_GET_FROM_ID";
// RECRUITMENT CANDIDATES
export const GETTER_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_DEMAND_CONTACTED";
export const GETTER_RECRUITMENT_CANDIDATES_GET_APPLIED = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_APPLIED";
export const GETTER_RECRUITEMENT_CANDIDATES_GET_TOTAL_APPLIED = "recruitment_candidates/GETTER_RECRUITEMENT_CANDIDATES_GET_TOTAL_APPLIED";
export const GETTER_RECRUITMENT_CANDIDATES_GET_CONTACTED = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_CONTACTED";
export const GETTER_RECRUITMENT_CANDIDATES_GET_RECRUITED = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_RECRUITED";
export const GETTER_RECRUITMENT_CANDIDATES_GET_IGNORED = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_IGNORED";
export const GETTER_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS = "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_REPORT_REASONS";
export const GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS =
  "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LOCATION_OPTIONS";
export const GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS =
  "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS";
export const GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS =
  "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS";
export const GETTER_RECRUITMENT_CANDIDATES_GET_ACTUAL_LOADING_NUMBER =
  "recruitment_candidates/GETTER_RECRUITMENT_CANDIDATES_GET_ACTUAL_LOADING_NUMBER";
// EXTRA
export const GETTER_EXTRA_GET_CURRENT = "extra/GETTER_EXTRA_GET_CURRENT";
export const GETTER_EXTRA_AS_PERMANENT_CANDIDATE_GET_CURRENT = "extra/GETTER_EXTRA_AS_PERMANENT_CANDIDATE_GET_CURRENT";
export const GETTER_EXTRA_GET_SKILLS = "extra/GETTER_EXTRA_GET_SKILLS";
export const GETTER_EXTRA_GET_BIO = "extra/GETTER_EXTRA_GET_BIO";
export const GETTER_EXTRA_GET_LANGUAGE = "extra/GETTER_EXTRA_GET_LANGUAGE";
export const GETTER_EXTRA_GET_EXTRA_SKILLS = "extra/GETTER_EXTRA_GET_EXTRA_SKILLS";
export const GETTER_EXTRA_GET_HACCP_CERTIF = "extra/GETTER_EXTRA_GET_HACCP_CERTIF";
export const GETTER_EXTRA_GET_COURSES = "extra/GETTER_EXTRA_GET_COURSES";
export const GETTER_EXTRA_GET_EXPERIENCES = "extra/GETTER_EXTRA_GET_EXPERIENCES";
// RECRUITMENTS
export const GETTER_RECRUITMENTS_GET_IN_PROGRESS = "recruitments/GETTER_RECRUITMENTS_GET_IN_PROGRESS";
export const GETTER_RECRUITMENTS_GET_UPCOMING = "recruitments/GETTER_RECRUITMENTS_GET_UPCOMING";
export const GETTER_RECRUITMENTS_GET_SELECTED = "recruitments/GETTER_RECRUITMENTS_GET_SELECTED";
export const GETTER_RECRUITMENTS_GET_SELECTED_EXTRA = "recruitments/GETTER_RECRUITMENTS_GET_SELECTED_EXTRA";
export const GETTER_RECRUITMENTS_GET_SOFT_REMOVED = "recruitments/GETTER_RECRUITMENTS_GET_SOFT_REMOVED";
// RECRUITMENT
export const GETTER_RECRUITMENT_GET_CURRENT = "recruitment/GETTER_RECRUITMENT_GET_CURRENT";
// SUBSCRIPTION
export const GETTER_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS = "subscription/GETTER_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS";
export const GETTER_SUBSCRIPTION_GET_SELECTED_OFFER = "subscription/GETTER_SUBSCRIPTION_GET_SELECTED_OFFER";
export const GETTER_SUBSCRIPTION_GET_PAYMENT_SESSION = "subscription/GETTER_SUBSCRIPTION_GET_PAYMENT_SESSION";
export const GETTER_SUBSCRIPTION_GET_PAYMENT_LINK = "subscription/GETTER_SUBSCRIPTION_GET_PAYMENT_LINK";
export const GETTER_SUBSCRIPTION_HAS_SUBSCRIPTION = "subscription/GETTER_SUBSCRIPTION_HAS_SUBSCRIPTION";
// ACTIVATION
export const GETTER_ACTIVATION_GET_DEMAND_RECAP = "activation/GETTER_ACTIVATION_GET_DEMAND_RECAP";
// SUBSCRIBED
export const GETTER_SUBSCRIBED_GET_INFORMATIONS = "subscribed/GETTER_SUBSCRIBED_GET_INFORMATIONS";
// SURVEY
export const GETTER_SURVEY_GET_AMOUNT = "survey/GETTER_SURVEY_GET_AMOUNT";
export const GETTER_SURVEY_GET_EXTRA_SCHEDULES = "survey/GETTER_SURVEY_GET_EXTRA_SCHEDULES";
export const GETTER_SURVEY_GET_EXTRA_REVIEWS = "survey/GETTER_SURVEY_GET_EXTRA_REVIEWS";
// SESSION
export const GETTER_SESSION_SHOULD_DISPLAY_FILTERS = "session/GETTER_SESSION_SHOULD_DISPLAY_FILTERS";
// REPORT MODAL
export const GETTER_REPORT_DEMAND_GET = "report_modal/GETTER_REPORT_DEMAND_GET";
export const GETTER_REPORT_MODAL_GET = "report_modal/GETTER_REPORT_MODAL_GET";
export const GETTER_REPORT_CANDIDATE_ID_GET = "report_modal/GETTER_REPORT_CANDIDATE_ID_GET";
export const GETTER_REPORT_CANDIDATE_FIRSTNAME_GET = "report_modal/GETTER_REPORT_CANDIDATE_FIRSTNAME_GET";
